import { GiveUpReasonList } from '@/pages/task-advertiser/constants';

export const GIVE_UP_REASON_LIST = GiveUpReasonList.map((v) => ({ value: v, label: v }));

export const LEARN_TASK_STATUS_LIST = [
  { label: '未处理', value: 0 },
  { label: '已完成', value: 1 },
  { label: '标记完成', value: 2 },
  { label: '已忽略', value: 3 },
  { label: '过期', value: 4 },
  { label: '未开始', value: 5 },
];

export const TASK_STATUS_LIST = [
  { label: '未启动', value: 0 },
  { label: '进行中', value: 1 },
  { label: '部分完成', value: 2 },
  { label: '全部完成', value: 3 },
];

export const TASK_COLLECT_LIST = [
  { label: '全部', value: 0 },
  { label: '仅收藏任务', value: 1 },
];

// 是否测试任务
export const TASK_IS_TEST_LIST = [
  { label: '全部', value: '' },
  { label: '是', value: 1 },
  { label: '否', value: 0 },
];

// 账户归属
export const ADV_GENERATION_LIST = [
  { label: '一代', value: 1 },
  { label: '二代', value: 2 },
  { label: '客户', value: 3 },
];

// 策略状态（私有库）
export const AGENCY_STRATEGY_STATUS_LIST = [
  { label: '测试', value: 10010 },
  { label: '正式', value: 10100 },
];
